import { Component, Inject, OnInit } from '@angular/core';
import { StoreService } from '../store.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-refresh',
  templateUrl: './refresh.component.html',
  styleUrls: ['./refresh.component.scss'],
})
export class RefreshComponent implements OnInit {
  paymentProvider = 'https://connect.stripe.com';

  constructor(
    private readonly storeService: StoreService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.storeService
      .getOnboardingLink()
      .subscribe(
        (link) =>
          (this.document.location.href = this.paymentProvider + link.url)
      );
  }
}
